<i class="k-icon k-font-icon k-i-close dialog-close" (click)="onClose()"></i>
<div class="container-fluid">
  <div class="row">
    <div class="container">
      <div class="dialog-title">Delete Environment</div>
      <p class="errors" [ngClass]="{ 'has-errors': !!error }" *ngIf="error">
        {{ error }}
      </p>
      <p>
        Are you sure you want to delete environment
        <strong>{{ environment.name }}</strong> and all associated tools?
      </p>
      <button
        themeColor="primary"
        class="dialog-button"
        (click)="onSubmit()"
        kendoButton
      >
        Yes, delete environment
      </button>
    </div>
  </div>
</div>
